import "@/App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import StickyButtons from "@/components/WhatsAppFAB";

// Lazy load pages für Code-Splitting
const LandingPage = lazy(() => import("@/pages/LandingPage"));
const Impressum = lazy(() => import("@/pages/Impressum"));
const Datenschutz = lazy(() => import("@/pages/Datenschutz"));
const WimpernverlaengerungPage = lazy(() => import("@/pages/WimpernverlaengerungPage"));
const WimpernliftingPage = lazy(() => import("@/pages/WimpernliftingPage"));
const AugenbrauenliftingPage = lazy(() => import("@/pages/AugenbrauenliftingPage"));

// Loading-Komponente
const PageLoader = () => (
  <div className="min-h-screen bg-cream flex items-center justify-center">
    <div className="text-center">
      <div className="inline-block w-12 h-12 border-4 border-gold border-t-transparent rounded-full animate-spin mb-4"></div>
      <p className="font-sans text-navy text-sm">Lädt...</p>
    </div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-cream">
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/wimpernverlaengerung-aachen" element={<WimpernverlaengerungPage />} />
              <Route path="/wimpernlifting-aachen" element={<WimpernliftingPage />} />
              <Route path="/augenbrauenlifting-aachen" element={<AugenbrauenliftingPage />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
            </Routes>
          </Suspense>
          <StickyButtons />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
